import { AppTextList } from '@norlys-a-s/norlys-play-kmm';
import { kmm } from './kmm';

export const appTextKeys = {
  forgotPassword: 'forgot_password',
  gdpr: 'norlys_play_gdpr'
};

const responseMapper = (data: AppTextList, key: string): any => {
  const arrayData = data.values.asJsReadonlyArrayView();
  switch (key) {
    case appTextKeys.forgotPassword:
      return {
        initial: arrayData[0],
        emailSent: arrayData[1],
        emailSentTo: arrayData[2],
        help: arrayData[3]
      };
    case appTextKeys.gdpr:
      return {
        title: arrayData[0],
        main: arrayData[1],
        last: arrayData[2],
        link: arrayData[3]
      };
    default:
      throw new Error(`Unknown key: ${key}`);
  }
};

export async function getAppTextKMM(key: string): Promise<any> {
  const appText = await kmm((repo) => repo.getAppTextList(key), false);
  return responseMapper(appText, key);
}
